import { Switch, Text } from '@mantine/core';
import React from 'react';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';

export const PresentAsSwitch = ({
	presentAsTimeline,
	setPresentAsTimeline,
}: {
	presentAsTimeline: boolean;
	setPresentAsTimeline: (isTimeline: boolean) => void;
}) => {
	const tCapManage = useTranslationCapManage();

	const switchTimelineLabel = tCapManage('holding.details.present_as.timeline');
	const switchTableLabel = tCapManage('holding.details.present_as.table');
	const longerSwitchLabelLength = Math.max(switchTimelineLabel.length, switchTableLabel.length);

	return (
		<Switch
			onLabel={
				<Text fz="sm" c="dark.8" fw={400}>
					{switchTimelineLabel}
				</Text>
			}
			offLabel={
				<Text fz="sm" c="dark.8" fw={400}>
					{switchTableLabel}
				</Text>
			}
			checked={presentAsTimeline}
			onChange={(event) => setPresentAsTimeline(event.currentTarget.checked)}
			color="blue.6"
			label={
				<Text fz="md" c="gray.9">
					{tCapManage('holding.details.present_as.label')}
				</Text>
			}
			labelPosition="left"
			radius="sm"
			size="lg"
			thumbIcon={
				presentAsTimeline ? (
					<Icon size="lg" variant="branch" />
				) : (
					<Icon size="lg" variant="table-v3" color="#0E171C" />
				)
			}
			className="default-switch"
			sx={(theme) => ({
				'.mantine-Switch-body': {
					alignItems: 'center',
				},
				'.mantine-Switch-label': {
					paddingRight: '0.25rem',
				},
				'.mantine-Switch-trackLabel': {
					minWidth: `${longerSwitchLabelLength * 8}px`,
					width: `${longerSwitchLabelLength * 8}px`,
					placeContent: 'center start',
				},
				'& :checked:not(:disabled)+.mantine-Switch-track': {
					backgroundColor: theme.colors.blue[0],
					border: `1px solid ${theme.colors.blue[2]}`,

					'.mantine-Switch-trackLabel': {
						backgroundColor: theme.colors.blue[0],
					},

					'.mantine-Switch-thumb': {
						border: `1px solid ${theme.colors.blue[4]}`,
					},
				},
			})}
		/>
	);
};
